// extracted by mini-css-extract-plugin
export default {"text":"SsoLoginError_text__PhE4C"};